module.exports = __webpack_public_path__ + "svg/SourceSansPro-SemiBold.svg?9349c9f942eb2f5ff798d372ee765029";